export function getElementAttribute(element, attribute, property) {
    if (element == null) return null;

    return element.dataset == null
        ? element.getAttribute(attribute) || element.getAttribute(`data-${attribute}`)
        : element.dataset[property];
}



// WEBPACK FOOTER //
// ./src/utils/pageData/domElementsUtil.js